export function buildUseAndCareHref(
	sku: string,
	slug: string,
	base = "/shop/useandcare"
): string {
	return `${base}/${encodeURIComponent(slug)}/${encodeURIComponent(sku)}`;
}
